<h1 mat-dialog-title>User Created</h1>
<div mat-dialog-content>
    User Created Successfully!
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</div>
